import type { RelayMetadata } from '@/contexts/AppContext';

/**
 * App default relays. Used as the initial `relayMetadata` for new users and as
 * a fallback when the user has no NIP-65 relay list configured (e.g. during
 * nostrconnect handshakes before any user relays have been loaded).
 */
export const APP_RELAYS: RelayMetadata = {
  relays: [
    { url: 'wss://nostr.bch.ninja/', read: true, write: true },
    { url: 'wss://nostr-relay.psfoundation.info', read: true, write: true },
    { url: 'wss://relay.ditto.pub', read: true, write: true },
    { url: 'wss://relay.primal.net', read: true, write: true },
    { url: 'wss://relay.damus.io', read: true, write: true },
  ],
  updatedAt: 0,
};

/** BCH-specific Nostr relays, shown prominently in the UI */
export const BCH_RELAYS = [
  'wss://nostr.bch.ninja/',
  'wss://nostr-relay.psfoundation.info',
];
